var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "37px",
    viewBox: "0 0 39 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-copy",
    transform: "translate(-1075.000000, -2028.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(100.000000, 1988.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(945.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-11",
    transform: "translate(30.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22 L0,26.9998824 C5.14624506,26.9998824 9.33267457,31.4859428 9.33267457,37 L14,37 C14,28.7287378 7.71969697,22 0,22",
    id: "Fill-1",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12 L0,16.9995059 C10.5864118,16.9998588 19.199729,25.9722904 19.199729,37 L24,37 C24,23.2150984 13.2333536,12.0003529 0,12",
    id: "Fill-3",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,31 L0,37 L6,37 C6,33.6866177 3.31380576,31 0,31",
    id: "Fill-5",
    fill: "#FF7800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    fill: "#146E6E",
    opacity: 0.910667783
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.96797,21.2633282 L33.7016348,17.1731464 L33.7016348,8.16667364 L28.7918401,8.16667364 L28.7918401,13.3601282 L11.6730456,0.0646827273 L0.337552718,8.16331 L0.359035236,8.19223727 C2.70894545,8.27061 4.98817126,8.61639182 7.16830029,9.20099182 L11.5476154,6.07112818 L28.7918401,19.4627736 L28.7918401,36.7609464 L33.7016348,36.7609464 L33.7016348,23.2757918 L35.9018604,24.9845191 L38.96797,21.2633282 Z",
    id: "Fill-7"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogoSmall);
export default __webpack_public_path__ + "static/media/app_logo_small.9b6264a6.svg";
export { ForwardRef as ReactComponent };